/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedChangeEmail
 */
export interface PatchedChangeEmail {
  /**
   *
   * @type {string}
   * @memberof PatchedChangeEmail
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedChangeEmail
   */
  email?: string;
}

/**
 * Check if a given object implements the PatchedChangeEmail interface.
 */
export function instanceOfPatchedChangeEmail(value: object): value is PatchedChangeEmail {
  return true;
}

export function PatchedChangeEmailFromJSON(json: any): PatchedChangeEmail {
  return PatchedChangeEmailFromJSONTyped(json, false);
}

export function PatchedChangeEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedChangeEmail {
  if (json == null) {
    return json;
  }
  return {
    password: json['password'] == null ? undefined : json['password'],
    email: json['email'] == null ? undefined : json['email'],
  };
}

export function PatchedChangeEmailToJSON(value?: PatchedChangeEmail | null): any {
  if (value == null) {
    return value;
  }
  return {
    password: value['password'],
    email: value['email'],
  };
}
